// Lazy-load heavy scripts after page load
window.addEventListener('load', () => {
  setTimeout(() => {
    const scripts = [
      "/wpm/b3918e4e0wbf3ac3cepc5707306mb02b36c6m.js",
      "/wpm/s3918e4e0wbf3ac3cepc5707306mb02b36c6m.js",
      "/s/trekkie.storefront.7909846.min.js",
      "/perf-kit/shopify-perf-kit-3.1.0.min.js",
      "/assets/vendor.js?v=1315314",
      "/assets/theme.js?v=6218564"
    ];

    scripts.forEach(src => {
      const s = document.createElement('script');
      s.src = src;
      s.defer = true; // defer execution
      document.body.appendChild(s);
    });
  }, 1000); // delay 1s to prioritize initial render
});
function batchDOMUpdate(elements, batch = 50) {
  let i = 0;
  function process() {
    const limit = Math.min(i + batch, elements.length);
    for (; i < limit; i++) {
      elements[i].classList.add('processed'); // your DOM change
    }
    if (i < elements.length) requestIdleCallback(process);
  }
  process();
}

const blocks = document.querySelectorAll('.promotion-block__image');
if (blocks.length) batchDOMUpdate(blocks);
(function(){
  let ticking = false;
  function handleScrollResize() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        // place expensive DOM reads/writes here if needed
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', handleScrollResize);
  window.addEventListener('resize', handleScrollResize);
})();
